import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "#80143421"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M20 10C17.38 10 15.25 12.13 15.25 14.75C15.25 17.32 17.26 19.4 19.88 19.49C19.96 19.48 20.04 19.48 20.1 19.49C20.12 19.49 20.13 19.49 20.15 19.49C20.16 19.49 20.16 19.49 20.17 19.49C22.73 19.4 24.74 17.32 24.75 14.75C24.75 12.13 22.62 10 20 10Z",
  fill: "#801434"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M25.0809 22.1499C22.2909 20.2899 17.7409 20.2899 14.9309 22.1499C13.6609 22.9999 12.9609 24.1499 12.9609 25.3799C12.9609 26.6099 13.6609 27.7499 14.9209 28.5899C16.3209 29.5299 18.1609 29.9999 20.0009 29.9999C21.8409 29.9999 23.6809 29.5299 25.0809 28.5899C26.3409 27.7399 27.0409 26.5999 27.0409 25.3599C27.0309 24.1299 26.3409 22.9899 25.0809 22.1499Z",
  fill: "#801434"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';

interface IProps {
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileUserICon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})